import { useCallback, useRef } from "react"

import { ModeEditIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import { L2RButton } from "../L2RButton"

import * as Styled from "./ImageField.styled"

export const ImageField = (props) => {
    const {
        alt,
        buttonLabel,
        className,
        error,
        filePreview,
        handleChange,
        helperText,
        imageSource,
        ...fileFieldProps
    } = props

    const isMobile = useIsMobileDevice()
    const fileInputRef = useRef()
    const onClick = useCallback(() => {
        return fileInputRef?.current?.click()
    }, [])
    return (
        <>
            <Styled.Wrapper className={className}>
                <Styled.Avatar
                    alt={alt}
                    src={(filePreview ?? imageSource) || undefined}
                    onClick={onClick}
                    isMobile={isMobile}
                    {...fileFieldProps}
                />

                <L2RButton variant="secondary" onClick={onClick} startIcon={<ModeEditIcon />}>
                    {buttonLabel}
                </L2RButton>
                <Styled.HiddenInput {...fileFieldProps} type="file" accept="image/*" onChange={handleChange} ref={fileInputRef} />
            </Styled.Wrapper>
            {
                error && helperText && <Styled.FormHelperText error>{helperText}</Styled.FormHelperText>
            }
        </>
    )
}

ImageField.propTypes = {
    alt: PropTypes.string.isRequired,
    buttonColor: PropTypes.string,
    buttonLabel: PropTypes.string.isRequired,
    className: PropTypes.string,
    filePreview: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    imageSource: PropTypes.string,
}